module.exports = __webpack_public_path__ + "img/dpl.5d18df33.png";